import { File } from '../objects/file';
import {AppComponent} from "../app.component";

const KB = 1024;
const MB = KB * KB;
const GB = MB * KB;

export const DAY = 86400000;

export const hoursToSeconds = (hourStr: string): number => {
  const HH_MM = hourStr.split(':');
  return parseInt(HH_MM[0])*3600+parseInt(HH_MM[1])*60;
}

export const getFormatedSize = (value: number, precision: number = 1): string => {
  if (value === null || value === undefined || Number.isNaN(value)) {
    return 'N/A'
  };

  if (value < KB) {
    return `${Math.round(value * precision) / precision} Bytes`;
  }
  if (value < MB) {
    return `${Math.round(value / KB * precision) / precision} KB`;
  }
  if (value < GB) {
    return `${Math.round(value / MB * precision) / precision} MB`;
  }
  return `${Math.round(value / GB * precision) / precision} GB`;
}

export const getDownloadZipName = (files: File[]): string => {
  const getZipNameByDate = function (): string {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const mon = currentDate.getMonth();
    const day = currentDate.getDate();
    const hor = currentDate.getHours();
    const min = currentDate.getMinutes();
    const sec = currentDate.getSeconds();

    return window.location.host.split('.')[0] + '_' + year +
      (mon < 9 ? '0' + (1 + mon) : (1 + mon)) +
      (day < 10 ? '0' + day : day) + '_' +
      (hor < 10 ? '0' + hor : hor) +
      (min < 10 ? '0' + min : min) + (sec < 10 ? '0' + sec : sec) + '.zip';
  }
  const fileNameParts = files[0].full_path.split('/');
  const downloadFileName = files.length > 1
    ? fileNameParts[fileNameParts.length - 2]
      ? `${fileNameParts[fileNameParts.length - 2]}.zip` : getZipNameByDate()
    : files[0].isFile ? fileNameParts[fileNameParts.length - 1] : `${fileNameParts[fileNameParts.length - 1]}.zip`;
  return downloadFileName;
}

export const parseYoutubeVideoID = (youtubeURL:string): string => {
  const regExp:RegExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
  const match = youtubeURL.match(regExp);
  if (match && match[7].length==11){
    return match[7];
  }else{
    return null;
  }
}

export const getFullTwoWeeks = (): Date => {
  let fromDate = new Date();
  let weekDay = fromDate.getDay() ? fromDate.getDay() : 7; // 1-7 => Mon-Sun
  let fullTwoWeeksTail = (weekDay == 1) ? 7 : 14;
  let remainingWeekDays = (7-weekDay);
  let toDate = new Date();
  toDate.setTime(fromDate.getTime()+(remainingWeekDays+fullTwoWeeksTail)*24*3600*1000);
  return toDate;
}

// export const extractCalendarIdFromPackage = (packageItem): number => {
//   let calendarID = -1;
//   packageItem['services'].forEach(service => {
//     if(calendarID == -1 && !isNaN(service['params']['calendarID'])) {
//       calendarID = service['params']['calendarID'];
//     }
//   })
//   return calendarID;
// }

export const extractCalendarStep = (duration: number): number => {
  return (duration > 1200) ? duration/2 : duration; //div 2 for long durations
}

export const extractDurationFromPackage = (packageItem, allCalendars): number => {
  let calendarID = -1;
  let duration = 0;
  //console.log('packageItem',packageItem)
  packageItem['services'].forEach(service => {
    if(calendarID == -1 && !isNaN(service['params']['calendarID'])) {
      calendarID = service['params']['calendarID'];
      let calendarSettings = getCalendarSettings(calendarID,allCalendars)
      duration = calendarSettings['duration']*service['qty'];
    }
  })
  return duration
}

export const getCalendarSettings = (calendarID,allCalendars): object => {
  let calendarItem;
  if(calendarID === 0) { //backward compatibility
    calendarItem = allCalendars[0]
  } else {
    calendarItem = allCalendars.find(calendar => calendar['ID'] == calendarID)
  }
  return calendarItem['settings']
}

export const getTimeWindow = (duration: number): string => {
  return (duration/60) + AppComponent.getLabel('mins');
}

export const themesList: Array<object> = [
  {
    'key': 'lightgrey-lightblue-red-theme', 'name': 'Default Light Blue Theme', 'demo-accent': '#039be5', 'demo-bg': '#fafafa'
  },
  {
    'key': 'lightgrey-orange-red-theme', 'name': 'Light Orange Theme', 'demo-accent': '#ff9800', 'demo-bg': '#fafafa'
  },
  {
    'key': 'lightgrey-lightgreen-red-theme', 'name': 'Light Green Theme', 'demo-accent': '#8bc34a', 'demo-bg': '#fafafa'
  },
  {
    'key': 'lightgrey-warm-red-theme', 'name': 'Light Warm Theme', 'demo-accent': '#fb8c00', 'demo-bg': '#fffde7'
  },
  {
    'key': 'lightgrey-evergreen-red-theme', 'name': 'Evergreen Theme', 'demo-accent': '#26a69a', 'demo-bg': '#b2dfdb'
  },
  {
    'key': 'dark-warm-red-theme', 'name': 'Dark Yellow Theme', 'demo-accent': '#fdd835', 'demo-bg': '#d84315'
  },
  {
    'key': 'dark-amber-red-theme', 'name': 'Amber Theme', 'demo-accent': '#ffd740', 'demo-bg': '#616161'
  },
  {
    'key': 'dark-grey-red-theme', 'name': 'Dark Grey Theme', 'demo-accent': '#bdbdbd', 'demo-bg': '#616161'
  }];

